// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"generate-speech-button_wrapper__lolbY"};